import cs from './const.js';
import AntAuth from './AntAuth';
import AntString from './AntString.js';
import { prepareJSONRequest } from './AntRequestCompression';
import stringify from './stableStringify';
import { resolveServiceRoutingHeaders } from './AntServiceRouting';
import { getClientInstanceId } from './AntClientInstance';

export default class BaseAPI {
    constructor() {}

    getSessionInfo() {
        const rawInfo = localStorage.getItem(cs.System_Code + '-session-info');

        try {
            const info = JSON.parse(rawInfo);
            return info && typeof info === 'object' ? info : {};
        } catch (error) {
            return {};
        }
    }

    getHeaders(token, includeContentType = true) {
        const info = this.getSessionInfo();
        const header = {
            Authorization: 'Bearer ' + token,
            'Business-Short-Code': info.business_short_code || '',
            'Business-Zone-Code': info.business_zone_code || '',
            'Business-Industry': info.business_industry || '',
            'Business-Sub-Industry': info.business_sub_industry || '',
            ...resolveServiceRoutingHeaders(info)
        };

        if (includeContentType) {
            header['Content-Type'] = 'application/json';
            header.Accept = 'application/json';
        }

        return header;
    }

    get(URL, cb) {
        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        if (!BaseURL || BaseURL==='null' || BaseURL ==='undefined' ) BaseURL = cs.BaseURL;

        var queryURL = AntString.clean(BaseURL + URL);

        const token = localStorage.getItem(cs.System_Code + '-session-token');
        const header = this.getHeaders(token);

        fetch(queryURL, {
            method: 'GET',
            headers: header
        })
            .then((response) => response.json())
            .then((data) => {
                AntAuth.verifyResponse(data);
                if (cb) cb(data);
            })
            .catch((er) => {
                if (cb) cb({ error: er });
            });
    }

    post(URL, body, cb) {
        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        if (!BaseURL || BaseURL==='null' || BaseURL ==='undefined' ) BaseURL = cs.BaseURL;

        var queryURL = AntString.clean(BaseURL + URL);

        const token = localStorage.getItem(cs.System_Code + '-session-token');
        const header = this.getHeaders(token);

        // Mã tab đi trong body (không thêm header): BE bóc ra ở AntRoute để socket tắt toast/âm thanh
        // đúng tab vừa thao tác.
        const sendBody = body && typeof body === 'object' && !Array.isArray(body) ? { ...body, _client_instance_id: getClientInstanceId() } : body;
        prepareJSONRequest(AntString.clean(stringify(sendBody)), header)
            .then((request) => fetch(queryURL, {
                method: 'POST',
                body: request.body,
                headers: request.headers
            }))
            .then((response) => response.json())
            .then((data) => {
                AntAuth.verifyResponse(data);
                if (cb) cb(data);
            })
            .catch((er) => {
                if (cb) cb({ error: er });
            });
    }

    upload(URL, formData, cb) {
        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        if (!BaseURL || BaseURL === 'null' || BaseURL === 'undefined') BaseURL = cs.BaseURL;

        var queryURL = AntString.clean(BaseURL + URL);

        const token = localStorage.getItem(cs.System_Code + '-session-token');
        const header = this.getHeaders(token, false);

        fetch(queryURL, {
            method: 'POST',
            body: formData,
            headers: header
        })
            .then((response) => response.json())
            .then((data) => {
                AntAuth.verifyResponse(data);
                if (cb) cb(data);
            })
            .catch((er) => {
                if (cb) cb({ error: er });
            });
    }

    // Upload file lớn qua presigned URL: (1) getUrl → (2) PUT trực tiếp S3 → (3) confirm
    uploadDirect(routeURL, file, code, onProgress, cb) {
        var that = this;
        // Step 1: Lấy presigned URL
        this.post('/' + routeURL + '/upload/getUrl', {
            fileName: file.name,
            contentType: file.type || 'application/octet-stream',
            fileSize: file.size,
            code: code
        }, function (result) {
            if (!result || result.error || !result.uploadUrl) {
                if (cb) cb(result || { error: true });
                return;
            }
            // Step 2: PUT trực tiếp lên S3
            var xhr = new XMLHttpRequest();
            xhr.open('PUT', result.uploadUrl);
            xhr.setRequestHeader('Content-Type', file.type || 'application/octet-stream');
            if (onProgress) {
                xhr.upload.onprogress = function (e) {
                    if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100));
                };
            }
            xhr.onload = function () {
                if (xhr.status >= 200 && xhr.status < 300) {
                    // Step 3: Confirm upload
                    that.post('/' + routeURL + '/upload/confirm', {
                        key: result.key,
                        fileName: file.name,
                        contentType: file.type,
                        fileSize: file.size,
                        code: code
                    }, function (confirmResult) {
                        if (cb) cb(confirmResult);
                    });
                } else {
                    if (cb) cb({ error: true, message: 'Upload failed: ' + xhr.status });
                }
            };
            xhr.onerror = function () {
                if (cb) cb({ error: true, message: 'Network error' });
            };
            xhr.send(file);
        });
    }

    download(URL, body, fileName, cb) {
        var BaseURL = localStorage.getItem(cs.System_Code + '-Sys_BaseURL');
        if (!BaseURL || BaseURL==='null' || BaseURL ==='undefined' ) BaseURL = cs.BaseURL;

        var queryURL = AntString.clean(BaseURL + URL);

        const token = localStorage.getItem(cs.System_Code + '-session-token');
        const header = this.getHeaders(token);

        prepareJSONRequest(AntString.clean(stringify(body)), header)
            .then((request) => fetch(queryURL, {
                method: 'POST',
                body: request.body,
                headers: request.headers
            }))
            .then((response) => {
                return response.blob();
            })
            .then((blob) => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                a.click();
                if (cb) cb(true);
            })
            .catch((er) => {
                if (cb) cb({ error: er });
            });
    }

    // async getListByURL(params, url) {
    //     var fields = [{ name: 'total', value: true }];

    //     if (params) {
    //         if (params instanceof Array) fields.push(...params);
    //         else if (typeof params == 'object') {
    //             Object.keys(params).forEach(function (key) {
    //                 if (params[key] !== undefined) fields.push({ name: key, value: params[key] });
    //             });
    //         }
    //     }

    //     var body = {};

    //     fields = fields
    //         .filter((p) => p.name && p.value !== undefined)
    //         .forEach((p) => {
    //             body[p.name] = p.value;
    //         });

    //     var URL = `/${url}`;

    //     var that = this;
    //     return new Promise((resolve) => {
    //         that.post(URL, body, (obj) => {
    //             if (obj && obj.data && obj.data.rows instanceof Array)
    //                 resolve({
    //                     rows: obj.data.rows,
    //                     totalCount: obj.data.totalCount
    //                 });
    //             else if (obj && obj.data instanceof Array)
    //                 resolve({
    //                     rows: obj.data,
    //                     totalCount: obj.data.length
    //                 });
    //             else
    //                 resolve({
    //                     rows: [],
    //                     totalCount: 0
    //                 });
    //         });
    //     });
    // }

    // async getListByURLGetMethod(params, url) {
    //     var fields = [{ name: 'total', value: true }];

    //     if (params) {
    //         if (params instanceof Array) fields.push(...params);
    //         else if (typeof params == 'object') {
    //             Object.keys(params).forEach(function (key) {
    //                 if (params[key] !== undefined) fields.push({ name: key, value: params[key] });
    //             });
    //         }
    //     }

    //     var query = fields
    //         .filter((p) => p.name && p.value !== undefined)
    //         .map((p) => `${p.name}=${p.value}`)
    //         .join('&');

    //     var hasParams = String(url).indexOf('?') >= 0;

    //     var URL = `/${url}${query ? (hasParams ? '&' : '?') + query : ''}`;

    //     var that = this;
    //     return new Promise((resolve) => {
    //         that.get(URL, (obj) => {
    //             if (obj && obj.data && obj.data.rows instanceof Array)
    //                 resolve({
    //                     rows: obj.data.rows,
    //                     totalCount: obj.data.totalCount
    //                 });
    //             else if (obj && obj.data instanceof Array)
    //                 resolve({
    //                     rows: obj.data,
    //                     totalCount: obj.data.length
    //                 });
    //             else
    //                 resolve({
    //                     rows: [],
    //                     totalCount: 0
    //                 });
    //         });
    //     });
    // }
}
